import { ConstantImport } from "./Constants/ConstantImport";
import { Bezel, BRANDING, EXT_SURFACE, INT_SURFACE } from "@spt/bezel";
import "../src/assets/css/styles.css";
import "../src/assets/css/KXAccomStyling.css";
import { ContainedApp } from "./ContainedApp";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from "react";

function App() {
  dayjs.extend(utc);
  dayjs.extend(customParseFormat);
  const [SiteAdmins, SetSiteAdmins] = useState<Array<String> | undefined>(undefined);
  const [CountedUser, SetCountedUser] = useState<string>();

  const _conf = {
    auth: {
      authority: ConstantImport.AccommodationAPI.Authority,
      clientId: ConstantImport.AccommodationAPI.ClientID,
      redirectUri: ConstantImport.AccommodationAPI.RedirectURI
    },
    scopes: [ConstantImport.AccommodationAPI.Scope]
    // auth: {
    //   authority: ConstantImport.MSALAuth.Authority,
    //   clientId: ConstantImport.MSALAuth.ClientID,
    //   redirectUri: ConstantImport.MSALAuth.RedirectURI
    // },
    // scopes: ["User.Read"]
  };

  return <Bezel
    Debug={false}
    ApplyUnauthenticatedTemplate={false}
    MSALConfig={_conf}
    UserAPI={{
      Scope: ConstantImport.UserAPI.Scope,
      TargetURL: ConstantImport.UserAPI.TargetURL
    }}
    BaseURL={ConstantImport.BaseURL}
    PageTitle="Accommodation Applications"
    Branding={BRANDING.EXTERNAL}
    InternalSurface={INT_SURFACE.NONE}
    ExternalSurface={EXT_SURFACE.ACCOMMODATION_PORTAL}
    ViewAsEnabled={SiteAdmins?.includes(CountedUser ?? "") ?? false}
    ViewAsMinimumViewEnabled={SiteAdmins?.includes(CountedUser ?? "") ?? false}
    CharmsEnabled={true}
  >
    <ContainedApp
      SiteAdmins={SiteAdmins}
      SetSiteAdmins={SetSiteAdmins}
      SetCountedUser={SetCountedUser}
    ></ContainedApp>
  </Bezel>
}

export default App;
